import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { IDashboardResponse } from "../../types/api/dashboardApi";
import { getDashboardDataQuery } from "../../api/dashboardApi";
import { DashboardState } from "../../types/features/dashboardSlice";


export const getDashboardData = createAsyncThunk<
  IDashboardResponse,
  void
>("dashboard/getDashboardData", async () => {
  const response = await getDashboardDataQuery();
  return response;
});

const DashboardSlice = createSlice({
  name: "Dashboard",
  initialState: {
    dashboardLoader: false,
    status: false,
    msg: "",
    data: null,
  } as DashboardState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardData.pending, (state) => {
        state.dashboardLoader = true;
      })
      .addCase(
        getDashboardData.fulfilled,
        (state, action: PayloadAction<IDashboardResponse>) => {
            // console.log(action.payload,"action.payload.data");
          state.data = action.payload.data;
          state.msg = action.payload.message;
          state.status = action.payload.status;
          state.dashboardLoader = false;
        }
      )
      .addCase(getDashboardData.rejected, (state, action) => {
        state.dashboardLoader = false;
        state.status = false;
        state.msg = action.error.message;
      });
  },
});

export default DashboardSlice.reducer;